import { ReactNode } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import EmptyList, { EmptyListConfigAction } from "go-core/components/EmptyList";

interface Props {
	children: ReactNode;
}

enum RedirectMethod {
	HOME,
	PREVIOUS,
}

const ErrorBoundaryFallback = ({ resetErrorBoundary }: FallbackProps) => {
	const { t } = useTranslation();
	const history = useHistory();

	const actions: EmptyListConfigAction[] = [
		{
			name: t("go_component.error_boundary.action.go_back.title", { ns: "lib" }),
			click: () => {
				if (history.length === 1) {
					resetErrorBoundary(RedirectMethod.HOME);
				} else {
					resetErrorBoundary(RedirectMethod.PREVIOUS);
				}
			},
		},
	];

	return (
		<EmptyList title={t("go_component.error_boundary.field.empty_list.title", { ns: "lib" })} actions={actions} />
	);
};

export const AppErrorBoundary = ({ children }: Props) => {
	const history = useHistory();

	const goBackHander = ({ args }: Record<string, any>) => {
		if (args[0] === RedirectMethod.HOME) {
			history.push(`/`);
		} else {
			history.goBack();
		}
	};

	return (
		<ErrorBoundary FallbackComponent={ErrorBoundaryFallback} onReset={goBackHander}>
			{children}
		</ErrorBoundary>
	);
};
